import * as React from 'react';

export function getPDFViewerComponent(pdfData: any) {

    return <object
                data={pdfData}
                type='application/pdf'
                style={{width: '100%', height: '100%'}}
            />;
}

